import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Assets from "../../Assets/Assets";
import "./Header.css";
import NotificationCenter from "./NotificationBell";
import NotificationToast from "./NotificationToast";
import useNotifications from "./useNotifications";
import { FiCopy } from "react-icons/fi";
import SubscriptionExpiringModal from "../../Pages/SubscriptionManagement/SubscriptionPopups/SubscriptionExpiringModal";
import ClinicPlanRenewalModal from "../../Pages/SubscriptionManagement/SubscriptionPopups/ClinicPlanRenewalModal";
import PaymentFailedModal from "../../Pages/SubscriptionManagement/SubscriptionPopups/PaymentFailedModal";
import AccountRestrictedModal from "../../Pages/SubscriptionManagement/SubscriptionPopups/AccountRestrictedModal";
import { GetAPI, PostAPI } from "../../ApiServices/ApiServices";
import { toast } from "react-toastify";
import Loader from "../Widgets/Loader";

const Header = () => {
  const navigate = useNavigate();

  const [profileImg, setProfileImg]         = useState(JSON.parse(localStorage.getItem("doctorData"))?.porfile_img || "");
  const [showExpiring, setShowExpiring]     = useState(false);
  const [showRenewal, setShowRenewal]       = useState(false);
  const [showPaymentFailed, setShowPaymentFailed] = useState(false);
  const [showRestricted, setShowRestricted] = useState(false);
  const [autoPay, setAutoPay]               = useState(true);
  const [remainingDays, setRemainingDays]   = useState(null);
  const [copied, setCopied]                 = useState(false);
  const [doctorData, setDoctorData]         = useState(
    JSON.parse(localStorage.getItem("doctorData") || "{}")
  );
  const [loading, setLoading] = useState(false);

  // ── Fetch subscription on mount ──────────────────────────────
  useEffect(() => {
    const doctorId       = doctorData?.id;
    const subscriptionId = doctorData?.existSubscription?.subscription_id;

    if (!doctorId || !subscriptionId) return;

    GetAPI(
      `/subscription/${doctorId}/${subscriptionId}/retrieved`,
      (res) => {
        if (!res?.success) return;

        const updatedDoctor = { ...doctorData, existSubscription: res.response };
        localStorage.setItem("doctorData", JSON.stringify(updatedDoctor));
        setDoctorData(updatedDoctor);

        // ✅ fix — is_active is boolean true/false
        setShowRestricted(!res.response.is_active);
      }
    );
  }, []);

useEffect(() => {
  if (remainingDays > 0 && remainingDays <= 5) {
    setShowExpiring(true);
  } else {
    setShowExpiring(false);
  }
}, [remainingDays]);
useEffect(() => {
  const sub = doctorData?.existSubscription;
  if (!sub) { setRemainingDays(null); return; }

  // ── Calculate expiry date ──
  let expiryDate = null;
  let isPastExpiry = false;

  if (sub.is_trial) {
    if (sub.trial_end_date) {
      expiryDate = new Date(sub.trial_end_date);
    } else if (sub.trial_remaining_days >= 0) {
      setRemainingDays(sub.trial_remaining_days);
      if (sub.trial_remaining_days === 0) setShowRestricted(true);
      return;
    }
  } else {
    if (sub.end_date) {
      expiryDate = new Date(sub.end_date);
    } else if (sub.next_billing_date) {
      expiryDate = new Date(sub.next_billing_date);
    } else if (sub.start_date) {
      // find next future billing date
      const billing = new Date(sub.start_date);
      const now = new Date();
      while (billing <= now) {
        billing.setMonth(billing.getMonth() + 1);
      }
      // check if previous billing cycle has passed
      const prevBilling = new Date(billing);
      prevBilling.setMonth(prevBilling.getMonth() - 1);
      isPastExpiry = prevBilling < now && billing > now;
      expiryDate = billing;
    }
  }

  if (!expiryDate) { setRemainingDays(null); return; }

  const now = new Date();
  const days = Math.ceil((expiryDate.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

  setRemainingDays(days > 0 ? days : 0);

  // ── Restrict if inactive OR past expiry ──
  if (!sub.is_active || expiryDate < now) {
    setShowRestricted(true);
  } else {
    setShowRestricted(false);
  }

}, [doctorData]);

  // ── Profile image update listener ───────────────────────────
  useEffect(() => {
    const handleStorageUpdate = () => {
      const d = JSON.parse(localStorage.getItem("doctorData")) || {};
      setProfileImg(d.profile_img_url || d.porfile_img || "");
    };
    window.addEventListener("doctorProfileUpdated", handleStorageUpdate);
    return () => window.removeEventListener("doctorProfileUpdated", handleStorageUpdate);
  }, []);

  // ── Renew API ────────────────────────────────────────────────
  const handleRenewNow = () => {
    const d              = JSON.parse(localStorage.getItem("doctorData") || "{}");
    const doctorId       = d?.id;
    const subscriptionId = d?.existSubscription?.subscription_id;

    if (!doctorId || !subscriptionId) {
      toast.error("Subscription details not found.");
      return;
    }
    setLoading(true);
    PostAPI(
      { url: `/subscription/${doctorId}/${subscriptionId}/renewal`, data: {} },
      (res) => {
        if (!res?.success) {
          toast.error(res?.message || "Renewal failed.");
          return;
        }
        toast.success(res?.message ||"Subscription renewed successfully!");
        setShowRenewal(false);
        setShowRestricted(false);
        setLoading(false);
        // const updatedDoctor = { ...d, existSubscription: res.response };
        // localStorage.setItem("doctorData", JSON.stringify(updatedDoctor));
        // setDoctorData(updatedDoctor);
      }
    );
  };

  // ── Copy booking link ────────────────────────────────────────
  const handleCopyBookingLink = async () => {
    const hashId = JSON.parse(localStorage.getItem("doctorData") || "{}")?.hash_id;
    if (!hashId) return;
    try {
      await navigator.clipboard.writeText(`https://v3doctor.digidoc.co.in/doctor/${hashId}`);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Copy failed:", err);
    }
  };
// calculate expiry date for display
const getExpiryDisplayDate = () => {
  const sub = doctorData?.existSubscription;
  if (!sub) return "—";

  if (sub.end_date) return new Date(sub.end_date).toLocaleDateString("en-IN");
  if (sub.next_billing_date) return new Date(sub.next_billing_date).toLocaleDateString("en-IN");
  if (sub.trial_end_date) return new Date(sub.trial_end_date).toLocaleDateString("en-IN");

  if (sub.start_date) {
    const expiry = new Date(sub.start_date);
    const now = new Date();
    while (expiry <= now) {
      expiry.setMonth(expiry.getMonth() + 1);
    }
    return expiry.toLocaleDateString("en-IN");
  }

  return "—";
};
  const { notifications, unreadCount, toasts, dismissToast, markAsRead, markAllAsRead, handleNotificationClick } = useNotifications();

  return (
    <div className="header-main">
      <div className="header-section">

        <div className="header-left-sec">
          <p className="date-txt">
            {new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" })}
          </p>
        </div>

        {/* Expiry warning */}
{remainingDays !== null &&
 remainingDays > 0 &&
 remainingDays <= 5 && (
  <a
    href="#!"
    className="text-decoration-none"
    onClick={(e) => {
      e.preventDefault();
      setShowExpiring(true);
    }}
  >
    <span className="text-muted">
      {remainingDays} Day{remainingDays > 1 ? "s" : ""} Remaining
    </span>{" "}
    <span className="text-danger fw-semibold text-decoration-underline">
     {doctorData?.existSubscription?.is_trial ? "Upgrade Subscription" : "Renew Subscription"}
    </span>
  </a>
)}
        {/* Modals */}
  <SubscriptionExpiringModal
  show={showExpiring}
  onClose={() => setShowExpiring(false)}
  expiryDate={getExpiryDisplayDate()} // ← use function
  onRenewNow={() => { setShowExpiring(false); handleRenewNow(); }}
/>

        <ClinicPlanRenewalModal
          show={showRenewal}
          onClose={() => setShowRenewal(false)}
          validity="1 Month"
          amount="999"
          gst="180"
          total="1179"
          autoPay={autoPay}
          onAutoPayChange={setAutoPay}
          onConfirmPay={() => { setShowRenewal(false); setShowPaymentFailed(true); }}
        />

        <PaymentFailedModal
          show={showPaymentFailed}
          onClose={() => setShowPaymentFailed(false)}
          reason="Transaction Timeout"
          onRetryPayment={() => { setShowPaymentFailed(false); setShowRenewal(true); }}
        />

        <AccountRestrictedModal
          show={showRestricted}
          onRenewNow={handleRenewNow}
          onContactSupport
        />

        <div className="header-right-sec">
          <div className="position-relative d-inline-block">
            <button className="btn bg-dg c-w d-flex gap-1" onClick={handleCopyBookingLink}>
              Appointment Link <FiCopy size={18} />
            </button>
            {copied && <div className="copy-tooltip-bottom">Copied!</div>}
          </div>

          <NotificationCenter
            notifications={notifications} unreadCount={unreadCount}
            onMarkAsRead={markAsRead} onMarkAllRead={markAllAsRead}
            onNotificationClick={handleNotificationClick}
          />

          <img src={profileImg} alt="Profile" className="profile-icon"
            onClick={() => navigate("/profile")}
            style={{ cursor: "pointer" }}
            onError={(e) => { e.target.src = Assets.profile_icon; }}
          />
        </div>
      </div>
    {loading && (
      <Loader/>
    )}
      <NotificationToast toasts={toasts} onDismiss={dismissToast} onNotificationClick={handleNotificationClick} />
    </div>
  );
};

export default Header;